import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';

export default function ForgotPasswordPage() {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    const result = await forgotPassword(email);
    setLoading(false);
    if (result.success) {
      setMessage(result.message);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-8" data-testid="forgot-password-page">
      <div className="w-full max-w-sm space-y-8 bg-white border border-zinc-200 p-8">
        <div>
          <h1 className="text-4xl font-black tracking-tighter text-zinc-950">Reset Password</h1>
          <p className="mt-2 text-sm text-zinc-500">Enter your email to receive a reset link</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {error && <div className="bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm" data-testid="forgot-error">{error}</div>}
          {message && <div className="bg-green-50 border border-green-200 text-green-700 text-sm p-3 rounded-sm" data-testid="forgot-success">{message}</div>}

          <div className="space-y-2">
            <Label htmlFor="email" className="text-xs font-medium tracking-[0.1em] uppercase text-zinc-500">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@agency.com" className="rounded-none border-zinc-300 focus:border-black" data-testid="forgot-email-input" required />
          </div>

          <Button type="submit" disabled={loading} className="w-full rounded-none bg-black text-white hover:bg-zinc-800" data-testid="forgot-submit-button">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </Button>
        </form>

        <Link to="/login" className="block text-sm text-zinc-500 hover:text-black transition-colors" data-testid="back-to-login-link">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
